<ion-header>
  <ion-toolbar>
    <ion-title>{{ "modals.voucher_modal.header" | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<div class="block">
  <ion-content>
    <div
      *ngIf="serviceType === 'voucher'"
      class="ion-padding d-flex flex-col ion-align-items-center"
    >
      <div
        *ngFor="let voucherDetail of vouchersInfo; let i = index"
        class="voucherCode"
      >
        <div class="logo">
          <ion-img [src]="voucherDetail?.logo"></ion-img>
        </div>

        <ion-card class="ion-padding voucher-card grey-border ion-no-margin">
          <div class="coupon-code voucher-card-inner">
            <ion-text class="fs-5 font600 offer-text card-primary-text-color">
              {{ voucherDetail?.offerText }}
            </ion-text>
            <ion-text class="fs-3 font600 card-primary-text-color">
              To Save, Use Barcode or Voucher Code
            </ion-text>
            <div class="voucher-box">
              <ion-text
                class="fs-4 font600 card-primary-text-color"
                (click)="copyToClipboard(voucherDetail?.code)"
              >
                Voucher Code: {{ voucherDetail?.code }}
              </ion-text>
            </div>

            <ion-text class="fs-3 font500 card-secondary-text-color">
              To Save, Use Barcode or Voucher Code
            </ion-text>

            <ion-text class="fs-3 font500 card-secondary-text-color">
              Valid Till - {{ formatDate(voucherDetail?.endDate) }}
            </ion-text>
          </div>
        </ion-card>
      </div>
    </div>

    <div
      *ngIf="serviceType === 'voucher_v2' && vouchersInfo[0]?.code"
      class="ion-padding d-flex flex-col ion-align-items-center"
    >
      <ion-card
        *ngIf="subscribedTier"
        class="ion-no-margin border-r10 {{
          subscribedTier?.tier?.toLowerCase() === 'premium' ? 'premium' : 'lite'
        }}"
      >
        <ion-card-content
          class="d-flex flex-col ion-align-items-start ion-justify-content-between"
        >
          <div class="tx-logo">
            <ion-img [src]="subscribedTier?.icon"></ion-img>
          </div>
          <div class="d-flex ion-justify-content-center voucherCode">
            <h2 class="fs-4 font600 ion-no-padding ion-text-uppercase">
              {{ vouchersInfo[0]?.code }}
            </h2>
          </div>
          <div class="w100 card-footer">
            <span
              class="tierinfo ion-float-start ion-text-capitalize fs-1 font500"
            >
              {{ subscribedTier?.tierTitle || subscribedTier?.tier }}
              <ion-icon
                class="marl4 marr4 member-rating-icon"
                name="star"
              ></ion-icon>
              <ion-icon
                class="marl4 marr4 member-rating-icon"
                name="star"
              ></ion-icon>
              <ion-icon
                class="marl4 marr4 member-rating-icon"
                name="star"
              ></ion-icon>
            </span>
            <span class="validity ion-float-end fs-2 font400">
              {{ "modals.voucher_modal.expiry" | translate }} -
              {{ formatDate(vouchersInfo?.[0]?.endDate) }}
            </span>
          </div>
        </ion-card-content>
      </ion-card>

      <ion-text class="font14 font500 ion-margin"
        >Scan this QR code at the gym for access</ion-text
      >
      <qrcode
        class="qrCode ion-margin"
        (qrCodeURL)="onChangeURL($event)"
        [qrdata]="myAngularxQrCode"
        [width]="130"
        [errorCorrectionLevel]="'M'"
      ></qrcode>
      <ion-item class="ion-no-margin ion-margin-top" lines="none">
        <ion-label class="font12 font500" slot="start">
          Total Available Access
        </ion-label>
        <ion-label class="font12 font500" slot="end">
          {{ totalCount }} Access Allowed
        </ion-label>
      </ion-item>
    </div>
  </ion-content>
</div>

<ion-footer class="padb5">
  <ion-toolbar class="pad5 ion-bg-white">
    <ion-button
      expand="block"
      class="primary-btn book-btn fs-3 font500"
      (click)="closeModal()"
    >
      Close
    </ion-button>
  </ion-toolbar>
</ion-footer>
